import { Slide, styled } from '@mui/material';
import { DEFAULT_TOOLBAR_HEIGHT, DEFAULT_YELLOW_LINE } from './Header/styles';

interface TabPanelProps {
  children?: JSX.Element;
  width?: string;
  visible: boolean;
  direction: 'right' | 'left';
}

const headerHeight = DEFAULT_YELLOW_LINE + DEFAULT_TOOLBAR_HEIGHT;

const Container = styled('div', { shouldForwardProp: (prop) => prop !== 'width' })<{ width?: string }>(({ width, theme }) => ({
  width: width || '35%',
  minWidth: '360px',
  maxWidth: width || '400px',
  maxHeight: `calc(100vh - (${theme.spacing(8)} + ${headerHeight}px))`,
  position: 'sticky',
  top: theme.spacing(4),
  background: theme.palette.neutral[300],
  borderRadius: '16px',
  padding: theme.spacing(4),
}));

export const TabPanel = (props: TabPanelProps): JSX.Element => {
  const { children, visible, width, direction } = props;

  return (
    <Slide in={visible} direction={direction} mountOnEnter unmountOnExit>
      <Container width={width}>{children}</Container>
    </Slide>
  );
};

export default TabPanel;
